import Cookies from 'js-cookie';

const authReducer = (draft, action) => {
    switch (action.type) {
        case "setUser":
            draft.user = action.data;
            return
        case "login":
            draft.loggedIn = true;
            draft.user = action.data;
            return
        case "logout":
            draft.loggedIn = false;
            draft.user = '';
            Cookies.remove('accessToken');
            Cookies.remove('authUser');
            return
        default:
            return
    }
};

export default authReducer;